import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LOGO_SRC } from '../../utils/assets';
import { SOCIAL_LINKS } from '../../utils/socialLinks';
import LanguageToggle from './LanguageToggle';

const Footer = () => {
  const { t } = useTranslation('common');
  return (
    <footer className="bg-white w-full">
      <div className="h-1 bg-applauss" />
      <div className="flex flex-col items-center gap-5 px-6 pt-10 pb-8">
        <div className="flex flex-col items-center gap-2">
          <img
            src={LOGO_SRC}
            alt="applauss"
            className="h-[38px] w-auto"
          />
          <p className="text-sm font-medium text-black/70 text-center">{t('footerTagline')}</p>
        </div>

        <nav className="flex flex-col items-center gap-[5px] text-sm font-medium text-black/65">
          <button type="button" className="hover:text-black transition-colors">{t('aboutUs')}</button>
          <Link to="/faq" className="hover:text-black transition-colors">{t('faq')}</Link>
          <Link to="/contact" className="hover:text-black transition-colors">{t('contact')}</Link>
        </nav>

        <div className="inline-flex flex-col gap-4">
          <div className="flex items-center gap-[30px] pt-[11px]">
            {SOCIAL_LINKS.map(({ label, href, Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="text-black hover:opacity-70 transition-opacity"
              >
                <Icon className="w-[30px] h-[30px]" />
              </a>
            ))}
          </div>
          <div className="h-px bg-black/10 scale-x-[1.2]" />
        </div>

        <LanguageToggle />

        <div className="flex flex-col items-center gap-[10px] text-xs text-black/60 text-center">
          <p>
            <Link to="/terms" className="hover:text-black transition-colors">{t('termsLink')}</Link>
            {' · '}
            <Link to="/privacy" className="hover:text-black transition-colors">{t('privacyLink')}</Link>
            {' · '}
            <Link to="/cookies" className="hover:text-black transition-colors">{t('cookiesLink')}</Link>
            {' · '}
            <Link to="/legal-notice" className="hover:text-black transition-colors">{t('legalNoticeLink')}</Link>
          </p>
          <p>{t('copyright', { year: new Date().getFullYear() })}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
